"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect, useCallback } from "react";

export const PRODUCTS_FEED_DATA_TESTID = "data-products-feed";

export const getCategoryDataTestid = (id: number) => `data-testid-${id}`;

export const navigateToProducts = () => {
  const productsFeed = document.querySelector(
    `[data-testid=${PRODUCTS_FEED_DATA_TESTID}]`,
  );
  productsFeed?.scrollIntoView({ behavior: "smooth" });
};

const scrollBy = (yPosition: number) => {
  window.scrollBy({
    top: yPosition,
    behavior: "smooth",
  });
};

export const useNavigate = () => {
  const pathname = usePathname();
  const router = useRouter();

  const handleScrollAfterNavigation = useCallback(() => {
    const scrollData = sessionStorage.getItem("scrollAfterNavigation");
    if (!scrollData) return;

    const [id, name] = scrollData.split(" ");
    const yPosition = categoryY([+id, name]);

    if (yPosition) {
      scrollBy(yPosition);
    }
    sessionStorage.removeItem("scrollAfterNavigation");
  }, []);

  useEffect(() => {
    handleScrollAfterNavigation();
  }, [pathname, handleScrollAfterNavigation]);

  const navigateToCategory = (id: number, name: string) => {
    if (pathname !== "/") {
      sessionStorage.setItem("scrollAfterNavigation", `${id} ${name}`);
      router.push("/");
      return;
    }
    const y = categoryY([id, name]);
    if (y) {
      scrollBy(y);
    }
  };

  const navigateToTop = () => {
    if (pathname !== "/") {
      router.push("/");
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  const goToPage = (url: string) => {
    router.push(url);
  };

  return { navigateToCategory, navigateToTop, goToPage };
};

export const categoryY = ([id, name]: [id: number, name: string]) => {
  const selector = `[data-testid="${getCategoryDataTestid(id)}"][aria-label="${name}"]`;
  const category = document.querySelector(selector);
  const y = category?.getBoundingClientRect().y;

  return y ? y - 64 : undefined;
};

export const navigateToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};
